import { startCase, toLower } from 'lodash';
export default function sentenceCase(str) {
    const formatted = startCase(toLower(str));
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
}
